import { useMemo } from "react";

import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";
import { useEnrollments } from "sj-ui-toolkit/src/api/hooks";
import { useBreadcrumb } from "sj-ui-toolkit/src/atlas/hooks/useBreadcrumbs";
import { PageBreadcrumb } from "sj-ui-toolkit/src/atlas/components";

import { LearninGrid } from "../LearninGrid/LearninGrid";

const QuestsPage = () => {
  const { quests, isLoadingQuests } = useLevelContext();
  const { data: enrollments = [] } = useEnrollments();

  useBreadcrumb({ label: "Quests", route: "/quests", display: "page" });

  const items = useMemo(() => {
    const enrolledQuestRoleIds = new Set(
      (enrollments ?? [])
        .filter(e => e.enrollmentType === "quest" && e.roleId != null)
        .map(e => e.roleId)
    );

    return (quests ?? [])
      .filter(q => !enrolledQuestRoleIds.has(q.role?.id))
      .map(q => ({
        id: q.role?.id,
        name: q.name,
        description: q.description,
        status: q.status,
      }));
  }, [quests, enrollments]);

  return (
    <div data-test-id="learn-quests-page">
      <PageBreadcrumb />
      <LearninGrid
        items={items}
        loading={isLoadingQuests}
        variant="indigo"
        pathType="Quest"
        title="Quests"
        searchInputId="quests-search"
      />
    </div>
  );
};

export default QuestsPage;
